const getBadgeVariant = (status: string | number) => {
    if (typeof status === 'string') return 'error';
    if (status >= 400 && status < 500) return 'warning';
    if (status >= 500) return 'error';
    return 'default';
};

export default getBadgeVariant;
